import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FiUploadCloud } from 'react-icons/fi';
import css from '../../../assets/styles/components/Pan.module.css';
import { apiRequest } from '../../store/allApi';
import images from '../loder.gif'

const OnlineKyc = ({ user }) => {
  const history = useHistory();
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);
  const [phone, setphone] = useState('');
  const [AadharNum, setAadharNum] = useState('');
  const [AadharOtp, setAadharOtp] = useState('');
  const [adharData, setUserAdharData] = useState('');
  const [Number, setNumber] = useState('');
  const [DOB, setDob] = useState('');
  const [submitProcess, setProcess] = useState(false);
  
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  const aadharProcess = useRef(false);

 const handleSubmitData = async (e) => {
  e.preventDefault();
setProcess(true)
  if (/^[0-9]{12}$/.test(AadharNum)) {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const data = {
      aadharNumber: AadharNum,
      phone : phone
    };

    try {
      const res = await apiRequest("admin/aadharcard-auto", "POST", data, headers);
      setUserAdharData(res?.data);
      setProcess(false);

      if (res.data.status === false) {
       Swal.fire({
  icon: "error",
  text: res?.data?.msg,
});
      } else {
        setProcess(false)
           Swal.fire({
  icon: "info",
  text: res?.data?.data?.message,
});
      }
    } catch (error) {
        setProcess(false)

      console.log(error);
    }
  } else {
        setProcess(false)

    Swal.fire({
      icon: "error",
      title: "Invalid Aadhar Number",
      text: "Please enter a valid 12-digit Aadhar number.",
    });
  }
};


const AdharOtp = async (e) => {
      setProcess(true);

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const data = {
      aadharNumber: AadharNum,
      otp: AadharOtp,
      phone: phone,
      transaction_id: adharData.data?.ref_id,
    };

    try {
      const res = await apiRequest(`admin/aadharcard-auto-verify`, "POST", data, headers)
      // setKycdata(res.data);
      // setVerifyData(res.data);
           setProcess(false);

      if (res.data.status === false) {
       Swal.fire({
  icon: "error",
  text: res?.data?.data?.message,
});
      } else {
      setProcess(false);
        history.push('/user/kyc');
      }
    } catch (e) {
      setProcess(false);

      console.log(e);
    }
  };


  useEffect(() => {
    let access_token = localStorage.getItem('token');
    if (!access_token) {
      window.location.reload();
      history.push('/login');
    }
  }, []);

  const handleFrontPhotoChange = e => {
    const [file] = e.target.files;
    setFrontLoaded(file);
  };

  const handleBackPhotoChange = e => {
    const [file] = e.target.files;
    setBackLoaded(file);
  };

  const theme = localStorage.getItem('theme');
  const styles = {
    backgroundColor: theme === 'light' ? '#fff' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
  };

  return (
    <div className={css.container}>
      <div className={css.formContainer}>
        <h1 className={css.heading} style={styles}>Enter Details for KYC</h1>
        <p className={css.subHeading} style={styles}>
          You need to submit a document that shows that you are above 18 years of age and not a resident of Assam, Odisha, Sikkim, Nagaland, Telangana, Andhra Pradesh, Tamil Nadu, and Karnataka.
        </p>
        <p className={css.subHeading} style={styles}>
          Enter details of Aadhar Card:
        </p>
        <form className={css.form} onSubmit={handleSubmitData}>
          <div className={css.inputGroup}>
            <input
              type="number"
              name="number"
              placeholder="phone no.."
              value={phone}
              onChange={e => setphone(e.target.value)}
              required
              className={css.input}
            />
          </div>
          <div className={css.inputGroup}>
            <input
              type="number"
              name="number"
              placeholder="Aadhar Number"
              onChange={e => setAadharNum(e.target.value)}
              required
              className={css.input}
            />
          </div>
          {
            adharData.data?.status == "SUCCESS" ?

            <div className={css.inputGroup}>
              <input
                type="number"
                name="AadharOtp"
                placeholder="AadharOtp"
                value={AadharOtp}
                onChange={e => setAadharOtp(e.target.value)}
                
                className={css.input}
              /> 
          </div> :""
          }
         
           {
            adharData.data?.status != "SUCCESS" ?
          <button type="submit" className={css.submitButton}>Get Otp</button> 
          : 
           <button type='button' className='btn-success' onClick={AdharOtp}>Submit Otp</button>
          }
        </form>
        {submitProcess && (
          <div className={css.loader}>
            <img src={images} alt="loading" className={css.loaderImage} />
          </div>
        )}
      </div>
    </div>
  );
};

export default OnlineKyc;
